import React, { useState, useEffect, useCallback } from 'react';
import AppShell from '../../components/layout/AppShell';
import api from '../../services/api';
import { adminApi , settingsApi} from '../../services/api';
import { fmtDT, fmtDate } from '../../utils/helpers';
import { Spinner, EmptyState, Modal } from '../../components/common';
import toast from 'react-hot-toast';
import { Plus, MapPin, Settings, Shield, ToggleLeft, ToggleRight, XCircle, Edit2, Trash2} from 'lucide-react';

export function HubsPage() {
  const [hubs, setHubs] = useState([]);
  const [zones, setZones] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [editHub, setEditHub] = useState(null);
  const [tab, setTab] = useState('hubs');
  const [form, setForm] = useState({ code:'', name:'', type:'BRANCH', city:'', country:'PK', address:'', lat:'', lng:'', capacity:'10000' });
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));
  const load = async () => { setLoading(true); try { const [h,z]=await Promise.all([adminApi.getHubs(),adminApi.getZones()]); if(h.success)setHubs(h.data); if(z.success)setZones(z.data); } finally{setLoading(false);} };
  useEffect(()=>{load();},[]);

  const openEdit = (h) => { setEditHub(h); setForm({ code:h.code, name:h.name, type:h.type, city:h.city||'', country:h.country||'PK', address:h.address||'', lat:h.lat||'', lng:h.lng||'', capacity:h.capacity||'10000' }); setShowAdd(true); };

  const createHub = async () => {
    if(!form.code||!form.name){toast.error('Code and name required');return;}
    try {
      if (editHub) {
        await api.patch('/admin/hubs/'+editHub.hub_id, form).then(r=>r.data);
        toast.success('Hub updated');
      } else {
        const r=await adminApi.createHub(form);
        if(!r.success) throw new Error(r.message);
        toast.success('Hub created');
      }
      setShowAdd(false); setEditHub(null); load();
    } catch(e){toast.error(e.message||'Failed');}
  };

  const deleteHub = async (hub) => {
    if(!window.confirm(`Delete hub "${hub.name}"? This cannot be undone.`)) return;
    try { await api.delete('/admin/hubs/'+hub.hub_id); toast.success('Hub deleted'); load(); }
    catch(e){ toast.error(e.response?.data?.message||'Cannot delete hub with active shipments'); }
  };
  return (
    <AppShell title="Hubs & Zones" actions={<button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={14}/> Add Hub</button>}>
      <div className="tabs">
        <div className={`tab${tab==='hubs'?' active':''}`} onClick={()=>setTab('hubs')}><MapPin size={13} style={{marginRight:6,display:'inline'}}/>Hubs ({hubs.length})</div>
        <div className={`tab${tab==='zones'?' active':''}`} onClick={()=>setTab('zones')}>Zones ({zones.length})</div>
      </div>
      {tab==='hubs' && <div className="card"><div className="table-wrap">{loading?<Spinner/>:hubs.length?(<table><thead><tr><th>Code</th><th>Name</th><th>Type</th><th>City</th><th>Staff</th><th>Status</th><th>Actions</th></tr></thead><tbody>{hubs.map(h=><tr key={h.hub_id}><td><code style={{fontSize:'.78rem',fontWeight:700}}>{h.code}</code></td><td style={{fontWeight:500}}>{h.name}</td><td><span className={`badge ${h.type==='HUB'?'badge-navy':h.type==='BRANCH'?'badge-info':'badge-gray'}`}>{h.type}</span></td><td>{h.city}</td><td>{h.staff_count||0}</td><td><span className={`badge ${h.is_active?'badge-success':'badge-gray'}`}>{h.is_active?'Active':'Inactive'}</span></td>
                    <td><div style={{display:'flex',gap:4}}>
                      <button className="btn btn-outline btn-sm" style={{fontSize:'.7rem'}} onClick={()=>openEdit(h)}>
                        <Edit2 size={12}/>
                      </button>
                      <button className="btn btn-danger btn-sm" style={{fontSize:'.7rem'}} onClick={()=>deleteHub(h)}>
                        <Trash2 size={12}/>
                      </button>
                    </div></td>
                  </tr>)}</tbody></table>):<EmptyState icon="🏢" title="No hubs configured"/>}</div></div>}
      {tab==='zones' && (
        <div className="card"><div className="table-wrap">{loading?<Spinner/>:zones.length?(
          <table><thead><tr><th>Code</th><th>Name</th><th>Country</th><th>Hub</th><th>Status</th><th>Actions</th></tr></thead>
          <tbody>{zones.map(z=>(
            <tr key={z.zone_id}>
              <td><code style={{fontSize:'.78rem',fontWeight:700}}>{z.code}</code></td>
              <td style={{fontWeight:500}}>{z.name}</td>
              <td>{z.country}</td>
              <td>{z.hub_name||'—'}</td>
              <td><span className={`badge ${z.is_active?'badge-success':'badge-gray'}`}>{z.is_active?'Active':'Inactive'}</span></td>
              <td><div style={{display:'flex',gap:4}}>
                <button className="btn btn-outline btn-sm" style={{fontSize:'.7rem'}} onClick={()=>{
                  const name=prompt('Zone name:',z.name);
                  if(name) api.patch('/admin/zones/'+z.zone_id,{name}).then(()=>{toast.success('Updated');load();}).catch(()=>toast.error('Failed'));
                }}><Edit2 size={11}/></button>
                <button className="btn btn-danger btn-sm" style={{fontSize:'.7rem'}} onClick={async()=>{
                  if(!window.confirm('Delete zone '+z.code+'?')) return;
                  try{await api.delete('/admin/zones/'+z.zone_id);toast.success('Deleted');load();}
                  catch(e){toast.error(e.response?.data?.message||'Failed');}
                }}><Trash2 size={11}/></button>
              </div></td>
            </tr>
          ))}</tbody></table>
        ):<EmptyState icon="🗺️" title="No zones"/>}</div></div>
      )}
      <Modal open={showAdd} onClose={()=>{setShowAdd(false);setEditHub(null);}} title={editHub?"Edit Hub":"Add Hub"}>
        <div className="modal-body">
          <div className="form-row"><div className="form-group"><label className="form-label">Code <span className="req">*</span></label><input className="form-control" placeholder="BR-KHI-02" value={form.code} onChange={set('code')}/></div><div className="form-group"><label className="form-label">Type</label><select className="form-control" value={form.type} onChange={set('type')}>{['HUB','BRANCH','FRANCHISE','WAREHOUSE'].map(t=><option key={t} value={t}>{t}</option>)}</select></div></div>
          <div className="form-group"><label className="form-label">Name <span className="req">*</span></label><input className="form-control" value={form.name} onChange={set('name')}/></div>
          <div className="form-row"><div className="form-group"><label className="form-label">City</label><input className="form-control" value={form.city} onChange={set('city')}/></div><div className="form-group"><label className="form-label">Country</label><select className="form-control" value={form.country} onChange={set('country')}>{['PK','AE','SA','GB'].map(c=><option key={c} value={c}>{c}</option>)}</select></div></div>
          <div className="form-group"><label className="form-label">Address</label><input className="form-control" value={form.address} onChange={set('address')}/></div>
          <div className="form-row"><div className="form-group"><label className="form-label">Latitude</label><input className="form-control" type="number" step="any" value={form.lat} onChange={set('lat')}/></div><div className="form-group"><label className="form-label">Longitude</label><input className="form-control" type="number" step="any" value={form.lng} onChange={set('lng')}/></div></div>
        </div>
        <div className="modal-footer"><button className="btn btn-outline" onClick={()=>setShowAdd(false)}>Cancel</button><button className="btn btn-primary" onClick={createHub}>{editHub?"Save Changes":"Create Hub"}</button></div>
      </Modal>
    </AppShell>
  );
}

export function TariffsPage() {
  const [tariffs, setTariffs] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showAdd, setShowAdd] = useState(false);
  const [tariffEdit, setTariffEdit] = useState(null);
  const [form, setForm] = useState({ name:'', serviceType:'DOM_STD', effectiveFrom:'', fuelSurcharge:'0', slabs:[{minWeight:'0',maxWeight:'',baseRate:'150',perKgRate:'20',minChargeable:'0.5'}] });
  const set = k => e => setForm(f=>({...f,[k]:e.target.value}));
  const loadT = () => { adminApi.getTariffs().then(r=>{if(r.success)setTariffs(r.data);}).finally(()=>setLoading(false)); };
  useEffect(()=>{ loadT(); }, []);
  const addSlab = () => setForm(f=>({...f,slabs:[...f.slabs,{minWeight:'',maxWeight:'',baseRate:'',perKgRate:'0',minChargeable:'0.5'}]}));
  const setSlab = (i,k,v) => setForm(f=>({...f,slabs:f.slabs.map((s,j)=>j===i?{...s,[k]:v}:s)}));
  const createTariff = async () => {
    if (tariffEdit) {
      try { await api.patch('/admin/tariffs/'+tariffEdit.tariff_id, { name:form.name, fuelSurcharge:parseFloat(form.fuelSurcharge) }); toast.success('Tariff updated'); setShowAdd(false); setTariffEdit(null); loadT(); } catch(e){ toast.error('Failed'); } return;
    }
    if(!form.name||!form.effectiveFrom){toast.error('Name and date required');return;}
    try{const r=await adminApi.createTariff({name:form.name,serviceType:form.serviceType,effectiveFrom:form.effectiveFrom,fuelSurcharge:parseFloat(form.fuelSurcharge),slabs:form.slabs.map(s=>({minWeight:parseFloat(s.minWeight)||0,maxWeight:s.maxWeight?parseFloat(s.maxWeight):null,baseRate:parseFloat(s.baseRate),perKgRate:parseFloat(s.perKgRate)||0,minChargeable:parseFloat(s.minChargeable)||0.5}))});if(r.success){toast.success('Tariff created');setShowAdd(false);}}catch(e){toast.error(e.message||'Failed');}
  };
  return (
    <AppShell title="Tariff Engine" actions={<button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}><Plus size={14}/> New Tariff</button>}>
      <div className="card"><div className="table-wrap">{loading?<Spinner/>:tariffs.length?(<table><thead><tr><th>Name</th><th>Service</th><th>Fuel SC%</th><th>Slabs</th><th>Effective From</th><th>Status</th></tr></thead><tbody>{tariffs.map(t=><tr key={t.tariff_id}><td style={{fontWeight:500}}>{t.name}</td><td><span className="badge badge-navy">{t.service_type}</span></td><td>{t.fuel_surcharge}%</td><td>{t.slab_count} slabs</td><td className="text-sm">{fmtDate(t.effective_from)}</td><td><span className={`badge ${t.is_active?'badge-success':'badge-gray'}`}>{t.is_active?'Active':'Inactive'}</span></td></tr>)}</tbody></table>):<EmptyState icon="💰" title="No tariffs" message={<button className="btn btn-primary btn-sm" onClick={()=>setShowAdd(true)}>Create First Tariff</button>}/>}</div></div>
      <Modal open={showAdd} onClose={()=>{setShowAdd(false);setTariffEdit(null);}} title={tariffEdit?'Edit Tariff':'Create Tariff'} size="modal-lg">
        <div className="modal-body">
          <div className="form-row"><div className="form-group"><label className="form-label">Name <span className="req">*</span></label><input className="form-control" value={form.name} onChange={set('name')}/></div><div className="form-group"><label className="form-label">Service Type</label><select className="form-control" value={form.serviceType} onChange={set('serviceType')}>{['DOM_STD','DOM_EXP','DOM_SD','DOM_ECO','INT_AIR','INT_SEA','INT_EXP','CARGO_BULK'].map(s=><option key={s} value={s}>{s}</option>)}</select></div></div>
          <div className="form-row"><div className="form-group"><label className="form-label">Effective From <span className="req">*</span></label><input className="form-control" type="date" value={form.effectiveFrom} onChange={set('effectiveFrom')}/></div><div className="form-group"><label className="form-label">Fuel Surcharge (%)</label><input className="form-control" type="number" step="0.1" min="0" value={form.fuelSurcharge} onChange={set('fuelSurcharge')}/></div></div>
          <div style={{fontWeight:600,fontSize:'.85rem',marginBottom:8}}>Weight Slabs</div>
          <table style={{width:'100%',borderCollapse:'collapse',marginBottom:8}}><thead><tr>{['Min kg','Max kg','Base Rate','Per kg','Min Charge'].map(h=><th key={h} style={{padding:'4px',fontSize:'.72rem',textAlign:'left',color:'var(--gray-500)',borderBottom:'1px solid var(--gray-200)'}}>{h}</th>)}</tr></thead><tbody>{form.slabs.map((s,i)=><tr key={i}>{['minWeight','maxWeight','baseRate','perKgRate','minChargeable'].map(k=><td key={k} style={{padding:'3px 4px'}}><input className="form-control" type="number" step="0.001" placeholder={k==='maxWeight'?'âˆž':'0'} value={s[k]} onChange={e=>setSlab(i,k,e.target.value)} style={{padding:'4px 8px',fontSize:'.8rem'}}/></td>)}</tr>)}</tbody></table>
          <button className="btn btn-outline btn-sm" onClick={addSlab}><Plus size={12}/> Add Slab</button>
        </div>
        <div className="modal-footer"><button className="btn btn-outline" onClick={()=>setShowAdd(false)}>Cancel</button><button className="btn btn-primary" onClick={createTariff}>Create Tariff</button></div>
      </Modal>
    </AppShell>
  );
}

export function AuditLogPage() {
  const [logs, setLogs] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loading, setLoading] = useState(true);
  const [page, setPage] = useState(1);
  const [filters, setFilters] = useState({ action:'', resourceType:'', fromDate:'', toDate:'' });
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const p = new URLSearchParams({ page, limit:50 });
      Object.entries(filters).forEach(([k,v])=>{ if(v) p.append(k,v); });
      const r = await api.get(`/admin/audit-logs?${p}`).then(r=>r.data);
      if (r.success) { setLogs(r.data); setPagination(r.pagination||{}); }
    } finally { setLoading(false); }
  }, [page, filters]);
  useEffect(()=>{load();},[load]);
  const exportCSV = () => {
    const rows=[['Date','Actor','Action','Resource','IP'],...logs.map(l=>[fmtDT(l.created_at),l.actor_name||l.actor_id,l.action,l.resource_type,l.ip_address])];
    const csv=rows.map(r=>r.join(',')).join('\n');
    const a=document.createElement('a');a.href='data:text/csv;charset=utf-8,'+encodeURIComponent(csv);a.download='audit-log.csv';a.click();
  };
  return (
    <AppShell title="Audit Log" actions={<div style={{display:'flex',gap:8}}><button className="btn btn-outline btn-sm" onClick={exportCSV}>â¬‡ Export CSV</button><button className="btn btn-outline btn-sm" onClick={load}>↻</button></div>}>
      <div className="filters-bar">
        <select className="form-control" style={{width:150}} value={filters.action} onChange={e=>setFilters(f=>({...f,action:e.target.value}))}><option value="">All Actions</option>{['INSERT','UPDATE','DELETE','LOGIN','LOGOUT','EXPORT'].map(a=><option key={a} value={a}>{a}</option>)}</select>
        <select className="form-control" style={{width:160}} value={filters.resourceType} onChange={e=>setFilters(f=>({...f,resourceType:e.target.value}))}><option value="">All Resources</option>{['shipments','customers','invoices','employees','tariffs','hubs'].map(r=><option key={r} value={r}>{r}</option>)}</select>
        <input className="form-control" type="date" style={{width:150}} value={filters.fromDate} onChange={e=>setFilters(f=>({...f,fromDate:e.target.value}))}/>
        <input className="form-control" type="date" style={{width:150}} value={filters.toDate} onChange={e=>setFilters(f=>({...f,toDate:e.target.value}))}/>
      </div>
      <div className="card">
        <div className="table-wrap">
          {loading?<Spinner/>:logs.length?(<table><thead><tr><th>Date/Time</th><th>Actor</th><th>Action</th><th>Resource</th><th>IP</th></tr></thead><tbody>{logs.map(l=><tr key={l.log_id}><td style={{fontFamily:'monospace',fontSize:'.78rem'}}>{fmtDT(l.created_at)}</td><td><div className="text-sm" style={{fontWeight:500}}>{l.actor_name||'—'}</div><div className="text-sm text-muted">{l.actor_role}</div></td><td><span className={`badge ${l.action==='DELETE'?'badge-danger':l.action==='INSERT'?'badge-success':l.action==='UPDATE'?'badge-warning':'badge-info'}`} style={{fontSize:'.68rem'}}>{l.action}</span></td><td className="text-sm">{l.resource_type}</td><td style={{fontFamily:'monospace',fontSize:'.75rem'}}>{l.ip_address||'—'}</td></tr>)}</tbody></table>):<EmptyState icon="📋" title="No audit logs found"/>}
        </div>
        {pagination.pages>1&&<div style={{display:'flex',justifyContent:'center',gap:8,padding:12}}><button className="btn btn-outline btn-sm" disabled={page<=1} onClick={()=>setPage(p=>p-1)}>â† Prev</button><span style={{fontSize:'.85rem',padding:'5px 12px'}}>Page {page} / {pagination.pages}</span><button className="btn btn-outline btn-sm" disabled={page>=pagination.pages} onClick={()=>setPage(p=>p+1)}>Next →</button></div>}
      </div>
    </AppShell>
  );
}

export function SecurityDashboardPage() {
  const [stats, setStats] = useState(null);
  const [sessions, setSessions] = useState([]);
  const [flags, setFlags] = useState([]);
  const [tab, setTab] = useState('sessions');
  const [loading, setLoading] = useState(true);
  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [s,sess,ff]=await Promise.all([api.get('/admin/security').then(r=>r.data),api.get('/admin/sessions').then(r=>r.data),api.get('/admin/feature-flags').then(r=>r.data)]);
      if(s.success)setStats(s.data); if(sess.success)setSessions(sess.data); if(ff.success)setFlags(ff.data);
    } finally{setLoading(false);}
  }, []);
  useEffect(()=>{load();},[load]);
  const revoke = async id => { try{await api.delete(`/admin/sessions/${id}`);toast.success('Revoked');load();}catch{toast.error('Failed');} };
  const toggleFlag = async key => { try{await api.patch(`/admin/feature-flags/${key}`);toast.success('Updated');load();}catch{toast.error('Failed');} };
  return (
    <AppShell title="Security Dashboard" actions={<button className="btn btn-outline btn-sm" onClick={load}>↻</button>}>
      <div className="stat-grid" style={{gridTemplateColumns:'repeat(3,1fr)',marginBottom:20}}>
        <div className="stat-card"><div className="stat-label"><Shield size={13} style={{marginRight:4,display:'inline'}}/>Active Sessions</div><div className="stat-value" style={{color:'var(--info)'}}>{stats?.activeSessions||0}</div></div>
        <div className="stat-card"><div className="stat-label">Failed Logins (24h)</div><div className="stat-value" style={{color:stats?.failedLogins24h>10?'var(--danger)':'var(--amber)'}}>{stats?.failedLogins24h||0}</div></div>
        <div className="stat-card"><div className="stat-label">Open Fraud Alerts</div><div className="stat-value" style={{color:stats?.openFraudAlerts>0?'var(--danger)':'var(--success)'}}>{stats?.openFraudAlerts||0}</div></div>
      </div>
      <div className="tabs">
        <div className={`tab${tab==='sessions'?' active':''}`} onClick={()=>setTab('sessions')}>Active Sessions ({sessions.length})</div>
        <div className={`tab${tab==='flags'?' active':''}`} onClick={()=>setTab('flags')}>Feature Flags ({flags.length})</div>
      </div>
      {tab==='sessions'&&<div className="card"><div className="table-wrap">{loading?<Spinner/>:sessions.length?(<table><thead><tr><th>User</th><th>Role</th><th>IP</th><th>Issued</th><th>Expires</th><th></th></tr></thead><tbody>{sessions.map(s=><tr key={s.session_id}><td style={{fontWeight:500}}>{s.user_name||'—'}</td><td><span className="badge badge-info" style={{fontSize:'.68rem'}}>{s.user_role}</span></td><td style={{fontFamily:'monospace',fontSize:'.78rem'}}>{s.ip_address||'—'}</td><td className="text-sm">{fmtDT(s.issued_at)}</td><td className="text-sm">{fmtDT(s.expires_at)}</td><td><button className="btn btn-danger btn-sm" style={{fontSize:'.7rem'}} onClick={()=>revoke(s.session_id)}><XCircle size={11}/> Revoke</button></td></tr>)}</tbody></table>):<EmptyState icon="🔐" title="No active sessions"/>}</div></div>}
      {tab==='flags'&&<div className="card"><div className="card-body" style={{display:'grid',gap:12}}>{flags.map(f=><div key={f.key} className="flex-between" style={{padding:'12px 0',borderBottom:'1px solid var(--gray-100)'}}><div><div style={{fontWeight:500}}>{f.label}</div><div style={{fontSize:'.75rem',color:'var(--gray-400)'}}>{f.key} · {f.env}</div></div><div style={{display:'flex',alignItems:'center',gap:10}}><span style={{fontSize:'.78rem',color:f.enabled?'var(--success)':'var(--gray-400)'}}>{f.enabled?'Enabled':'Disabled'}</span><button className="btn btn-outline btn-sm" onClick={()=>toggleFlag(f.key)}>{f.enabled?<ToggleRight size={16} color="var(--success)"/>:<ToggleLeft size={16}/>} {f.enabled?'Disable':'Enable'}</button></div></div>)}</div></div>}
    </AppShell>
  );
}

// =============================================================================
// SettingsPage component - replaces the static panel in AdminPages.js
//
// Drops in as a replacement for the existing `export function SettingsPage()`.
// Reads from GET /admin/settings (grouped by category) and lets ADMIN role
// edit individual values via PATCH /admin/settings/:key.
//
// UX:
//   - Sidebar tabs per category (tariff, tax, volumetric, service, finance,
//     notifications, branding, security, system)
//   - Right pane shows the settings in that category
//   - Each setting: label, current value (editable input), description, unit,
//     min/max hint, "Save" button per row
//   - is_editable=false rows are read-only (no save button, greyed)
//   - Audit-aware: saving writes an entry to audit_logs (handled server-side)
//
// Visual style: matches the cream/navy/amber theme from earlier patches.
// =============================================================================

export function SettingsPage() {
  const [grouped, setGrouped] = React.useState({});
  const [categories, setCategories] = React.useState([]);
  const [activeCat, setActiveCat] = React.useState(null);
  const [loading, setLoading] = React.useState(true);
  const [edits, setEdits] = React.useState({});       // { key: newValue }
  const [savingKeys, setSavingKeys] = React.useState({}); // { key: true }
  const [error, setError] = React.useState(null);

  // Load all settings, grouped
  const load = async () => {
    setLoading(true);
    setError(null);
    try {
      const r = await settingsApi.list();
      setGrouped(r.data.grouped || {});
      const cats = Object.keys(r.data.grouped || {}).sort();
      setCategories(cats);
      if (cats.length && !activeCat) setActiveCat(cats[0]);
    } catch (e) {
      setError(e.response?.data?.message || e.message || 'Failed to load settings');
    } finally {
      setLoading(false);
    }
  };

  React.useEffect(() => { load(); }, []);

  // Track edits without saving
  const onEdit = (key, value) => {
    setEdits(prev => ({ ...prev, [key]: value }));
  };

  // Save one row
  const onSave = async (setting) => {
    const newValue = edits[setting.key];
    if (newValue === undefined) return;
    setSavingKeys(prev => ({ ...prev, [setting.key]: true }));
    try {
      const r = await settingsApi.update(setting.key, newValue);
      if (r.success) {
        toast.success(`${setting.label} updated`);
        // Update grouped state with new server-returned value
        setGrouped(prev => {
          const next = { ...prev };
          next[setting.category] = next[setting.category].map(s =>
            s.key === setting.key ? { ...s, ...r.data } : s
          );
          return next;
        });
        setEdits(prev => {
          const next = { ...prev };
          delete next[setting.key];
          return next;
        });
      } else {
        toast.error(r.message || 'Save failed');
      }
    } catch (e) {
      toast.error(e.response?.data?.message || e.message || 'Save failed');
    } finally {
      setSavingKeys(prev => {
        const next = { ...prev };
        delete next[setting.key];
        return next;
      });
    }
  };

  // Category labels and icons
  const CATEGORY_META = {
    tariff:        { label: 'Tariff & Rates',  icon: '*' },
    tax:           { label: 'Tax',             icon: '%' },
    volumetric:    { label: 'Volumetric',      icon: '#' },
    service:       { label: 'Service TAT',     icon: '@' },
    finance:       { label: 'Finance',         icon: 'F' },
    notifications: { label: 'Notifications',   icon: '!' },
    branding:      { label: 'Branding',        icon: '~' },
    security:      { label: 'Security',        icon: '+' },
    system:        { label: 'System Info',     icon: '?' },
  };

  if (loading) {
    return (
      <AppShell title="System Settings">
        <div style={{ padding: 40, textAlign: 'center', color: 'var(--gray-500)' }}>
          Loading settings...
        </div>
      </AppShell>
    );
  }

  if (error) {
    return (
      <AppShell title="System Settings">
        <div className="alert alert-danger" style={{ maxWidth: 600 }}>
          <strong>Error:</strong> {error}
          <button className="btn btn-sm btn-outline" style={{ marginLeft: 12 }} onClick={load}>Retry</button>
        </div>
      </AppShell>
    );
  }

  const activeSettings = grouped[activeCat] || [];

  return (
    <AppShell title="System Settings">
      <div style={{ display: 'grid', gridTemplateColumns: '220px 1fr', gap: 16, maxWidth: 1100 }}>

        {/* Sidebar: categories */}
        <div className="card" style={{ alignSelf: 'start', padding: 0 }}>
          <div style={{ padding: '12px 14px', borderBottom: '1px solid var(--gray-100)' }}>
            <strong style={{ fontSize: '.85rem', color: 'var(--gray-600)' }}>CATEGORIES</strong>
          </div>
          <div>
            {categories.map(cat => {
              const meta = CATEGORY_META[cat] || { label: cat, icon: '-' };
              const count = grouped[cat]?.length || 0;
              const isActive = cat === activeCat;
              return (
                <div
                  key={cat}
                  onClick={() => setActiveCat(cat)}
                  style={{
                    padding: '10px 14px',
                    cursor: 'pointer',
                    borderLeft: isActive ? '3px solid var(--amber)' : '3px solid transparent',
                    background: isActive ? 'var(--cream-warm, #F1ECDF)' : 'transparent',
                    fontWeight: isActive ? 600 : 400,
                    color: isActive ? 'var(--navy)' : 'var(--gray-700)',
                    fontSize: '.88rem',
                    display: 'flex', alignItems: 'center', justifyContent: 'space-between',
                  }}
                >
                  <span>{meta.label}</span>
                  <span style={{
                    fontSize: '.72rem',
                    padding: '2px 7px',
                    borderRadius: 10,
                    background: 'var(--gray-100)',
                    color: 'var(--gray-600)',
                  }}>{count}</span>
                </div>
              );
            })}
          </div>
        </div>

        {/* Main pane: settings in active category */}
        <div style={{ display: 'grid', gap: 12 }}>
          {activeSettings.length === 0 ? (
            <div className="card"><div className="card-body" style={{ color: 'var(--gray-500)' }}>
              No settings in this category.
            </div></div>
          ) : (
            activeSettings.map(setting => {
              const editing = edits[setting.key] !== undefined;
              const currentValue = editing ? edits[setting.key] : setting.value;
              const isSaving = !!savingKeys[setting.key];
              const isReadOnly = !setting.is_editable;
              return (
                <div key={setting.key} className="card">
                  <div className="card-body" style={{ padding: 16 }}>
                    <div style={{ display: 'flex', alignItems: 'flex-start', gap: 16 }}>
                      <div style={{ flex: 1 }}>
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 4 }}>
                          <strong style={{ fontSize: '.95rem', color: 'var(--navy)' }}>{setting.label}</strong>
                          {isReadOnly && (
                            <span style={{
                              fontSize: '.65rem',
                              padding: '2px 6px',
                              borderRadius: 4,
                              background: 'var(--gray-200)',
                              color: 'var(--gray-600)',
                              textTransform: 'uppercase',
                              letterSpacing: '.05em',
                            }}>read-only</span>
                          )}
                        </div>
                        {setting.description && (
                          <div style={{ fontSize: '.8rem', color: 'var(--gray-500)', marginBottom: 8 }}>
                            {setting.description}
                          </div>
                        )}
                        <div style={{ fontSize: '.7rem', color: 'var(--gray-400)', fontFamily: 'monospace', marginBottom: 8 }}>
                          {setting.key}
                          {setting.min_value !== null && setting.max_value !== null &&
                            ` - range: ${setting.min_value} to ${setting.max_value}`}
                        </div>

                        <div style={{ display: 'flex', alignItems: 'center', gap: 8 }}>
                          <input
                            className="form-control"
                            type={setting.value_type === 'number' || setting.value_type === 'percent' ? 'number' : 'text'}
                            step={setting.value_type === 'percent' ? '0.1' : 'any'}
                            value={currentValue}
                            disabled={isReadOnly || isSaving}
                            onChange={e => onEdit(setting.key, e.target.value)}
                            style={{
                              maxWidth: 280,
                              background: isReadOnly ? 'var(--gray-50)' : 'var(--paper, #fff)',
                            }}
                          />
                          {setting.unit && (
                            <span style={{ color: 'var(--gray-500)', fontSize: '.85rem' }}>{setting.unit}</span>
                          )}
                          {editing && !isReadOnly && (
                            <>
                              <button
                                className="btn btn-amber btn-sm"
                                onClick={() => onSave(setting)}
                                disabled={isSaving}
                              >
                                {isSaving ? 'Saving...' : 'Save'}
                              </button>
                              <button
                                className="btn btn-outline btn-sm"
                                onClick={() => {
                                  setEdits(prev => {
                                    const next = { ...prev };
                                    delete next[setting.key];
                                    return next;
                                  });
                                }}
                                disabled={isSaving}
                              >Cancel</button>
                            </>
                          )}
                        </div>

                        {setting.updated_at && (
                          <div style={{ fontSize: '.7rem', color: 'var(--gray-400)', marginTop: 8 }}>
                            Last updated: {new Date(setting.updated_at).toLocaleString()}
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              );
            })
          )}

          <div className="alert alert-info" style={{ marginTop: 8, fontSize: '.82rem' }}>
            Changes take effect within 60 seconds across the platform. Audit log records every change.
          </div>
        </div>
      </div>
    </AppShell>
  );
}

